export default function Marquee({ items, className = "" }) {
  const row = items.join("  ·  ") + "  ·  ";
  return (
    <div className={`overflow-hidden border-y border-ink/10 bg-bone-dark py-4 ${className}`} data-testid="editorial-marquee">
      <div className="marquee-track">
        {[0, 1].map((n) => (
          <span key={n} className="whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-ink-soft pr-2">
            {row}
          </span>
        ))}
      </div>
    </div>
  );
}
